import { PROCESS } from "@/constants/testIds";

const steps = [
  {
    n: "01",
    title: "Share your story",
    body: "Tell us about your family, your goals, and your budget in a 60-second form — no medical exam, no commitment.",
  },
  {
    n: "02",
    title: "We compare 25+ carriers",
    body: "A real licensed agent reviews your situation and brings back the best two or three options. We explain the trade-offs in plain English.",
  },
  {
    n: "03",
    title: "Lock in your protection",
    body: "Most policies are approved in days, not weeks. Sign electronically, name your beneficiaries, and rest easy tonight.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid={PROCESS.section}
      className="py-16 sm:py-24 lg:py-32 bg-muted/40 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="overline mb-4">How it works</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-primary leading-[1.05] mb-8">
              Three quiet steps.<br />
              <em className="not-italic text-accent">One loud peace of mind.</em>
            </h2>
            <div className="hidden lg:block relative aspect-[4/3] rounded-3xl overflow-hidden soft-shadow">
              <img
                src="https://images.unsplash.com/photo-1758957851828-5179f0e06985"
                alt="Children playing"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <ol className="lg:col-span-7 space-y-6">
            {steps.map((s) => (
              <li
                key={s.n}
                className="group flex gap-6 lg:gap-10 p-8 rounded-3xl border border-border/60 bg-card hover-lift soft-shadow"
              >
                <span className="font-serif text-5xl lg:text-6xl italic text-accent leading-none shrink-0">
                  {s.n}
                </span>
                <div>
                  <h3 className="font-serif text-2xl lg:text-3xl text-primary mb-2 leading-tight">{s.title}</h3>
                  <p className="text-base leading-relaxed text-muted-foreground">{s.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
